import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import AppRoutes from './routes';
import { loadUserData } from './store/slices/authSlice';
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from './styles/theme';
import { GlobalStyles } from './styles/globalStyles';
import { useAppSelector } from './store';

const ThemedApp: React.FC = () => {
  const isDarkMode = useAppSelector(state => state.theme.isDarkMode);
  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles theme={theme} />
      <AppRoutes />
    </ThemeProvider>
  );
};

const AppContent: React.FC = () => {
  useEffect(() => {
    store.dispatch(loadUserData());
  }, []);

  return <ThemedApp />;
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;
